import { IFinancialInvoice as FinancialInvoice } from '../../models/financialInvoice';
import { 
    IInvoiceReport1, 
    IInvoiceReport2,
    IInvoiceFCReport1, 
    IInvoiceFCReport2,
} from '../../models/invoice';
import { MultiResponseType } from '../../models/multiResponseType';
import { SingleResponseType } from '../../models/singleResponseType';

export enum ActionType {
    FETCH_FINANCIALINVOICES = 'FETCH_FINANCIALINVOICES',
    FETCH_FINANCIALINVOICES_SUCCESS = 'FETCH_FINANCIALINVOICES_SUCCESS',
    FETCH_FINANCIALINVOICES_FAIL = 'FETCH_FINANCIALINVOICES_FAIL',
    FETCH_FINANCIALINVOICEREPORT1 = 'FETCH_FINANCIALINVOICEREPORT1',
    FETCH_FINANCIALINVOICEREPORT1_SUCCESS = 'FETCH_FINANCIALINVOICEREPORT1_SUCCESS',
    FETCH_FINANCIALINVOICEREPORT1_FAIL = 'FETCH_FINANCIALINVOICEREPORT1_FAIL',
    FETCH_FINANCIALINVOICEREPORT2 = 'FETCH_FINANCIALINVOICEREPORT2',
    FETCH_FINANCIALINVOICEREPORT2_SUCCESS = 'FETCH_FINANCIALINVOICEREPORT2_SUCCESS',
    FETCH_FINANCIALINVOICEREPORT2_FAIL = 'FETCH_FINANCIALINVOICEREPORT2_FAIL',

    FETCH_FINANCIALINVOICEFCREPORT1 = 'FETCH_FINANCIALINVOICEFCREPORT1',
    FETCH_FINANCIALINVOICEFCREPORT1_SUCCESS = 'FETCH_FINANCIALINVOICEFCREPORT1_SUCCESS',
    FETCH_FINANCIALINVOICEFCREPORT1_FAIL = 'FETCH_FINANCIALINVOICEFCREPORT1_FAIL',
    FETCH_FINANCIALINVOICEFCREPORT2 = 'FETCH_FINANCIALINVOICEFCREPORT2',
    FETCH_FINANCIALINVOICEFCREPORT2_SUCCESS = 'FETCH_FINANCIALINVOICEFCREPORT2_SUCCESS',
    FETCH_FINANCIALINVOICEFCREPORT2_FAIL = 'FETCH_FINANCIALINVOICEFCREPORT2_FAIL',       

    ADD_FINANCIALINVOICE = 'ADD_FINANCIALINVOICE',
    ADD_FINANCIALINVOICE_SUCCESS = 'ADD_FINANCIALINVOICE_SUCCESS',
    ADD_FINANCIALINVOICE_FAIL = 'ADD_FINANCIALINVOICE_FAIL',
    EDIT_FINANCIALINVOICE = 'EDIT_FINANCIALINVOICE',
    EDIT_FINANCIALINVOICE_SUCCESS = 'EDIT_FINANCIALINVOICE_SUCCESS',
    EDIT_FINANCIALINVOICE_FAIL = 'EDIT_FINANCIALINVOICE_FAIL',
    DELETE_FINANCIALINVOICE = 'DELETE_FINANCIALINVOICE',
    DELETE_FINANCIALINVOICE_SUCCESS = 'DELETE_FINANCIALINVOICE_SUCCESS',
    DELETE_FINANCIALINVOICE_FAIL = 'DELETE_FINANCIALINVOICE_FAIL'
}

export interface IFetchFinancialInvoices {
    type: ActionType.FETCH_FINANCIALINVOICES;
}
export interface IFetchFinancialInvoicesSuccess {
    type: ActionType.FETCH_FINANCIALINVOICES_SUCCESS;
    payload: MultiResponseType<FinancialInvoice>;
}
export interface IFetchFinancialInvoicesFail {
    type: ActionType.FETCH_FINANCIALINVOICES_FAIL;
    payload: string | null;
}

export interface IFetchFinancialInvoiceReport1 {
    type: ActionType.FETCH_FINANCIALINVOICEREPORT1;
}
export interface IFetchFinancialInvoiceReport1Success {
    type: ActionType.FETCH_FINANCIALINVOICEREPORT1_SUCCESS;
    payload: SingleResponseType<IInvoiceReport1>;
}
export interface IFetchFinancialInvoiceReport1Fail {
    type: ActionType.FETCH_FINANCIALINVOICEREPORT1_FAIL;
    payload: string | null;
}

export interface IFetchFinancialInvoiceFCReport1 {
    type: ActionType.FETCH_FINANCIALINVOICEFCREPORT1;
}
export interface IFetchFinancialInvoiceFCReport1Success {
    type: ActionType.FETCH_FINANCIALINVOICEFCREPORT1_SUCCESS;
    payload: SingleResponseType<IInvoiceFCReport1>;
}
export interface IFetchFinancialInvoiceFCReport1Fail {
    type: ActionType.FETCH_FINANCIALINVOICEFCREPORT1_FAIL;
    payload: string | null;
}

export interface IFetchFinancialInvoiceReport2 {
    type: ActionType.FETCH_FINANCIALINVOICEREPORT2;
}
export interface IFetchFinancialInvoiceReport2Success {
    type: ActionType.FETCH_FINANCIALINVOICEREPORT2_SUCCESS;
    payload: MultiResponseType<IInvoiceReport2>;
}
export interface IFetchFinancialInvoiceReport2Fail {
    type: ActionType.FETCH_FINANCIALINVOICEREPORT2_FAIL;
    payload: string | null;
}

export interface IFetchFinancialInvoiceFCReport2 {
    type: ActionType.FETCH_FINANCIALINVOICEFCREPORT2;
}
export interface IFetchFinancialInvoiceFCReport2Success {
    type: ActionType.FETCH_FINANCIALINVOICEFCREPORT2_SUCCESS;
    payload: MultiResponseType<IInvoiceFCReport2>;
}
export interface IFetchFinancialInvoiceFCReport2Fail {
    type: ActionType.FETCH_FINANCIALINVOICEFCREPORT2_FAIL;
    payload: string | null;
}

export interface IAddFinancialInvoice {
    type: ActionType.ADD_FINANCIALINVOICE;
}
export interface IAddFinancialInvoiceSuccess {
    type: ActionType.ADD_FINANCIALINVOICE_SUCCESS;
    payload: FinancialInvoice;
}
export interface IAddFinancialInvoiceFail {
    type: ActionType.ADD_FINANCIALINVOICE_FAIL;
    payload: string | null;
}

export interface IEditFinancialInvoice {
    type: ActionType.EDIT_FINANCIALINVOICE;
}
export interface IEditFinancialInvoiceSuccess {
    type: ActionType.EDIT_FINANCIALINVOICE_SUCCESS;
    payload: FinancialInvoice;
}
export interface IEditFinancialInvoiceFail {
    type: ActionType.EDIT_FINANCIALINVOICE_FAIL;
    payload: string | null;
}
export interface IDeleteFinancialInvoice {
    type: ActionType.DELETE_FINANCIALINVOICE;
}
export interface IDeleteFinancialInvoiceSuccess {
    type: ActionType.DELETE_FINANCIALINVOICE_SUCCESS;
    payload: number;
}
export interface IDeleteFinancialInvoiceFail {
    type: ActionType.DELETE_FINANCIALINVOICE_FAIL;
    payload: string | null;
}

export type Action =
    | IFetchFinancialInvoices
    | IFetchFinancialInvoicesSuccess
    | IFetchFinancialInvoicesFail
    | IFetchFinancialInvoiceReport1
    | IFetchFinancialInvoiceReport1Success
    | IFetchFinancialInvoiceReport1Fail
    | IFetchFinancialInvoiceReport2
    | IFetchFinancialInvoiceReport2Success
    | IFetchFinancialInvoiceReport2Fail
    | IFetchFinancialInvoiceFCReport1
    | IFetchFinancialInvoiceFCReport1Success
    | IFetchFinancialInvoiceFCReport1Fail
    | IFetchFinancialInvoiceFCReport2
    | IFetchFinancialInvoiceFCReport2Success
    | IFetchFinancialInvoiceFCReport2Fail
    | IAddFinancialInvoice
    | IAddFinancialInvoiceSuccess
    | IAddFinancialInvoiceFail
    | IEditFinancialInvoice
    | IEditFinancialInvoiceSuccess
    | IEditFinancialInvoiceFail
    | IDeleteFinancialInvoice
    | IDeleteFinancialInvoiceSuccess
    | IDeleteFinancialInvoiceFail
